import {Component} from '@packages/systems/wfdl';
import type {ExpressionElement} from '@packages/systems/wfdl-ast';
import {designerTranslation} from '@packages/systems/designer-translations';
import {
  isRichTextDescendant,
  isComponentInsidePageSlot,
} from '@packages/utilities/platform';
import {weakMemo} from '@packages/utilities/memo';

export const validateUnlink = weakMemo(
  (currentComponent: Component.ComponentType) =>
    weakMemo((componentMap: Component.ComponentMap) =>
      weakMemo((selectedElement: ExpressionElement) => {
        if (isComponentInsidePageSlot(componentMap, selectedElement)) {
          return 'Cannot unlink a Component inside a Page Slot';
        }

        if (
          isRichTextDescendant(
            Component.getRender(currentComponent),
            selectedElement
          )
        ) {
          return designerTranslation.t(
            'designer.components.rich-text.unlink-instance-disabled'
          );
        }

        return null;
      })
    )
);
